export default "__VITE_ASSET__CpfK26JK__"